module.exports = __webpack_public_path__ + "static/suez_image_1-b1b5c639915a8a91b2e2fbc8a706b624.jpg";